import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Send } from "lucide-react";
import "../../../assets/css/seller/ChatPage/ChatPage.css";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const ChatPage = () => {
  const { ticketId } = useParams();
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
   const [errorMessage, setErrorMessage] = useState("");
  const { baseUrl,regTpChecker,loggedInSeller  } = useContext(AppContext);
  const messagesEndRef = useRef(null);

 const viewAllMessages = () => {
  axios
    .get(`${baseUrl}/seller/chat/viewAllUploadedMessage/${ticketId}`)
    .then((res) => {
      console.log("Chat Response:", res.data);
      console.log("Messages:", res.data.message);

      setMessages(res.data.message);
    })
    .catch((err) => console.log(err));
};

  const sendMessage = () => {
    console.log(loggedInSeller);
    if (!newMessage.trim()) return;
    const formData = new FormData();
 formData.append("tphelpsupport_id", ticketId);
formData.append("tpshop_id", loggedInSeller.id);
formData.append("message", newMessage);
formData.append("sender", "shop");
    axios
      .post(`${baseUrl}/seller/chat/sendMessage`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        setNewMessage("");
        viewAllMessages();
      })
      .catch((err) => console.log("SEND ERROR:", err.response?.data));
  };

  useEffect(() => {
    viewAllMessages();
    console.log("Messages State:", messages);
  }, [ticketId,messages]);


  return (
    <SellerMasterLayout>
      <div className="sc-wrapper">
        {/* ── Header ── */}
        <div className="sc-header">
          <button
            className="sc-back-btn"
            onClick={() => navigate("/seller-supports")}
          >
            <ArrowLeft size={18} />
          </button>
          <div>
            <h3 className="sc-title">Ticket #{ticketId}</h3>
            <p className="sc-subtitle">Support Chat</p>
          </div>
        </div>

        {/* ── Chat Card ── */}
        <div className="sc-card">
          <div className="sc-card-top">Chat — {ticketId}</div>

          {/* Messages */}
          <div className="sc-messages">
            {messages.length === 0 ? (
              <p className="sc-empty">
                No messages yet. Start the conversation!
              </p>
            ) : (
              messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`sc-msg-row ${msg.sender === "shop" ? "sc-msg-row--right" : "sc-msg-row--left"}`}
                >
                  <div
                    className={`sc-bubble ${msg.sender === "shop" ? "sc-bubble--seller" : "sc-bubble--admin"}`}
                  >
                    <p>{msg.message}</p>
                    <span className="sc-sender">
  {msg.sender === "shop"
    ? "Shop"
    : msg.sender === "customer"
    ? "Customer"
    : "Admin"}
</span>
                  </div>
                </div>
              ))
            )}
            <div ref={messagesEndRef} />
          </div>
           {/* Error Message */}
            {errorMessage && (
              <div className="buyer-error-message">{errorMessage}</div>
            )}

          {/* Input */}
          <div className="sc-input-bar">
            <input
              className="sc-input"
              type="text"
              placeholder="Type a message..."
              value={newMessage}
              onChange={(e) => {setNewMessage(e.target.value)
                 setErrorMessage(regTpChecker("message", e.target.value));
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") sendMessage();
              }}
            />
            <button className="sc-send-btn" onClick={sendMessage}>
              <Send size={16} />
            </button>
          </div>
        </div>
      </div>
    </SellerMasterLayout>
  );
};

export default ChatPage;
